import React from "react";
import '../../css/components/controls/HrnbContainer.css'

export default function HrnbContainer({
                                          className = "",
                                          children,
                                          maxWidth = "1200px",
                                          style = {},
                                          ...props
                                      }) {
    return (
        <div
            className={`hrnb-container ${className}`}
            style={{ maxWidth, ...style }}
            {...props}
        >
            {children}
        </div>
    );
}

export function HrnbRow({ className = "", children, style = {}, ...props }) {
    return (
        <div className={`hrnb-row ${className}`} style={style} {...props}>
            {children}
        </div>
    );
}

export function HrnbCol({ col = 12, className = "", children, style = {}, ...props }) {
    return (
        <div
            className={`hrnb-col hrnb-col-${col} ${className}`}
            style={style}
            {...props}
        >
            {children}
        </div>
    );
}